module.exports = __webpack_public_path__ + "static/cineducacion.7bde8b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/cineducacion.jpg
// module id = 460
// module chunks = 202660965941462